import owd from 'owd/owd';

export default class Header extends owd.Component {
	init() {
		this.bind();
	}

	bind() {
        this.on('load ajaxload scroll resize', this.dom.$window, (e) => {
            let scrollTop = this.dom.$window.scrollTop();

            if (scrollTop > 80) {
                this.$element.addClass('is-collapsed');
            } else {
                this.$element.removeClass('is-collapsed');
            }
        })
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('header', {
	component: Header
});
